class LandingMobileCta extends HTMLElement {
  connectedCallback() {
    const scrollSelector = this.dataset.scrollSelector;
    const hideWhenId = this.dataset.hideWhenId;

    if (scrollSelector) this.setupScrollBehavior(scrollSelector);
    if (hideWhenId) this.setupVisibilityObserver(hideWhenId);
  }

  setupScrollBehavior(selector) {
    const buttonElement = this.querySelector('[data-cta-button]');
    if (!buttonElement) return;

    buttonElement.addEventListener('click', (clickEvent) => {
      const targetElement = document.querySelector(selector);
      if (!targetElement) return;
      clickEvent.preventDefault();
      targetElement.scrollIntoView({ behavior: 'smooth' });
    });
  }

  setupVisibilityObserver(sectionId) {
    const targetElement = document.getElementById(sectionId);
    if (!targetElement) return;

    const visibilityObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((observerEntry) => {
          this.classList.toggle('landing-mobile-cta--hidden', observerEntry.isIntersecting);
        });
      },
      { threshold: 0.1 }
    );

    visibilityObserver.observe(targetElement);
  }
}

customElements.define('landing-mobile-cta', LandingMobileCta);